import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-deadend',
  standalone: false,
  templateUrl: './deadend.component.html',
  styleUrl: './deadend.component.scss'
})
export class DeadendComponent implements OnInit {

  title = '';
  content = '';

  ngOnInit() {
    this.title = history.state.title || '';
    this.content = history.state.content || '';
  }

}
